import { useEffect } from 'react';
import { loadSession, saveSession } from '@helpers/sessionStorage';

export const hideLookBook = () => {
    document
        .querySelectorAll('.cms-product-look-book--visible')
        .forEach((element) => {
            element.classList.remove('cms-product-look-book--visible');
            document.body.removeAttribute('style');

            const scrollTop = loadSession('css:scrollTop');

            if (scrollTop) {
                window.scrollTo(0, scrollTop);
            }
        });
};

export const openLookBook = ({ target }) => {
    const { blockId = '' } = target.dataset;

    if (blockId) {
        const element = document.querySelector(`.cms-product-look-book[data-block-id="${blockId}"]`);

        if (element) {
            element.classList.add('cms-product-look-book--visible');
            const { scrollTop } = document.documentElement;

            saveSession('css:scrollTop', scrollTop);

            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
            document.body.style.marginTop = `-${scrollTop}px`;

            const elementHeader = element.querySelector('.cms-product-look-book__header');
            const elementBody = element.querySelector('.cms-product-look-book__container');

            if (elementHeader && elementBody) {
                elementBody.style.maxHeight = `${element.clientHeight - elementHeader.clientHeight - 20}px`;
            }

            if (document.body.classList.contains('listing')) {
                element.querySelectorAll('div[data-react-id]').forEach((el) => {
                    const props = {};

                    [].forEach.call(el.attributes, (attr) => {
                        if (/^data-/.test(attr.name)) {
                            const camelCaseName = attr.name
                                .substr(5)
                                .replace(/-(.)/g, ($0, $1) => $1.toUpperCase());
                            props[camelCaseName] = attr.value;
                        }
                    });

                    App.Component.RenderAtNode(el.dataset.reactId, el, props);
                });
            }
        }
    }
};

export const prepareLookBook = (phrases) => {
    document
        .querySelectorAll('.cms-product-look-book__shadow')
        .forEach((element) => {
            element.addEventListener('click', hideLookBook);
        });

    document
        .querySelectorAll('.cms-product-look-book__open')
        .forEach((element) => {
            element.addEventListener('click', openLookBook);
        });

    document
        .querySelectorAll('.cms-product-look-book__related-products-header')
        .forEach((element) => {
            element.innerText = phrases['magazine.related_product_label'];
        });

    const lookBooks = document.querySelectorAll('.cms-product-look-book');
    const totalLookBooks = lookBooks.length;

    lookBooks.forEach((element, iteration) => {
        const totalElement = element.querySelector('.cms-product-look-book__container__header__total');

        if (totalElement) {
            const phrase = phrases['magazine.look_{%iteration%}/{%totalLookBooks%}']
                .replace('{%iteration%}', iteration + 1)
                .replace('{%totalLookBooks%}', totalLookBooks);
            totalElement.innerHTML = `<span>${phrase}</span>`;
        }
    });
};

const destroyLookBook = () => {
    document
        .querySelectorAll('.cms-product-look-book__shadow')
        .forEach((element) => {
            element.removeEventListener('click', hideLookBook);
        });

    document
        .querySelectorAll('.cms-product-look-book__open')
        .forEach((element) => {
            element.removeEventListener('click', openLookBook);
        });
};

export const usePrepareLookBook = (phrases) => {
    useEffect(() => {
        prepareLookBook(phrases);

        return () => {
            destroyLookBook();
        };
    });
};
